import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('Sending message...');
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
      console.log("Sending to backend URL:", BACKEND_URL);
      
      if (!formData.name || !formData.email || !formData.message) {
        setStatus('Please fill in all fields');
        setIsSubmitting(false);
        return;
      }
      
      const res = await axios.post(`${BACKEND_URL}/send-message`, formData, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: false
      });
      
      if (res.status === 200) {
        setStatus('Thank you for reaching out! Your message has been sent.');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus('Something went wrong. Please try again.');
      }
    } catch (err) {
      console.error("Error details:", err);
      
      if (err.message === 'Network Error') {
        setStatus('Cannot connect to the server. Please check if the backend is running or try again later.');
      } else if (err.response) {
        setStatus(`Error: ${err.response.data.message || 'Server error, please try again'}`);
      } else {
        setStatus(`Failed to send message: ${err.message}`);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
        <div className="contact-form">
        <h2>Contact Us</h2>
        <form onSubmit={handleSubmit}>
            <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            />
            <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
            />
            <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
            ></textarea>
            <button type="submit">Send Message</button>
        </form>
        {status && <p className="status-message">{status}</p>}

        {/* Adsense ad */}
        <div style={{ margin: "30px auto", maxWidth: "100%" }}>
          <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2065338109976469" crossOrigin="anonymous"></script>
          {/* Contact Ad */}
          <ins className="adsbygoogle"
               style={{ display: "block" }}
               data-ad-client="ca-pub-2065338109976469"
               data-ad-slot="8321101898"
               data-ad-format="auto"
               data-full-width-responsive="true"></ins>
          <script>
            (adsbygoogle = window.adsbygoogle || []).push({});
          </script>
        </div>

        <div style={{ margin: "30px auto", maxWidth: "100%" }}>
          <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2065338109976469" crossOrigin="anonymous"></script>
          {/* contact2 */}
          <ins className="adsbygoogle"
               style={{ display: "block" }}
               data-ad-client="ca-pub-2065338109976469"
               data-ad-slot="7402771899"
               data-ad-format="auto"
               data-full-width-responsive="true"></ins>
          <script>
            (adsbygoogle = window.adsbygoogle || []).push({});
          </script>
        </div>

        <div style={{ marginTop: '20px', fontSize: '0.9rem', textAlign: 'center' }}>
          <p>If you're having trouble with the contact form, you can also reach me directly at:</p>
           <p style={{ fontWeight: 'bold', marginTop: '5px' }}>agnes@picapicabooth.com</p>
        </div>
      </div>
    </div>
    
  );
};

export default Contact;
